import { render, staticRenderFns } from "./PageBuilderProcessor.vue?vue&type=template&id=6f4f535a&"
import script from "./PageBuilderProcessor.vue?vue&type=script&lang=js&"
export * from "./PageBuilderProcessor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports